import { setSpecificMessage, empty } from "valibot";
setSpecificMessage(
  empty,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);